import kebabCase from 'lodash/kebabCase';
import { dateFormat } from './date-format';

export const getExportFileName = (...args: any) => {
  const name = [...args, dateFormat()].join('-');

  return kebabCase(name);
};
